// Sentry (lazy, only when VITE_SENTRY_DSN is set). Source maps are uploaded in CI.
import { clientEnv } from "./env";

export async function initErrors() {
  if (!clientEnv.sentryDsn) return;
  const Sentry = await import("@sentry/browser");
  Sentry.init({ dsn: clientEnv.sentryDsn, environment: clientEnv.appEnv, tracesSampleRate: 0.05, release: import.meta.env.VITE_RELEASE as string | undefined });
}
